/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   06/01/2023
 */

import React from "react";
import {FormControl, FormHelperText, TextField} from "@mui/material";

export interface SlackTextInputProps {
	multiline?: false
	label?: string
	placeholder?: string
	value: string
	onChange: (str: string) => void
}

export default function SlackTextInput(props: SlackTextInputProps) {

	return (
		<FormControl variant={"standard"} fullWidth>
			<TextField
				variant={"standard"}
				placeholder={props.placeholder}
				label={props.label || "Text"}
				value={props.value}
				onChange={(event) => {
					props.onChange(event.target.value);
				}}
			/>
			<FormHelperText>
				Standard slack <a href={"https://slack.com/help/articles/202288908-Format-your-messages"} target={"_blank"} rel={"noreferrer"}>text formatting</a> rules apply, e.g. *bold*, _underline_, etc.
			</FormHelperText>
		</FormControl>
	);

}